import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,
  dashboardHeader: '#26305a',
  dashboardWalletAmount: '#fff',
  dashboardWalletIcon: '#fff',
  dashboardLogoIcon: '#fff',
  dashboardBG: '#f2f2eb',
  dashboardBGStartGradient: '#323339',
  dashboardBGCenterGradient: '#323339',
  dashboardBGEndGradient: '#1B1D20',

  //theme for drawer
  drawerBackground: '#252d58',
  drawerHeaderTitleText: '#038afd',
  drawerHeaderBackground: '#040628',
  drawerMenuTitle: '#fff',
  drawerMenuIcon: '#fff',
  drawerMenuTitleArrowIcon: '#fff',
  drawerHeaderEmailText: '#fff',
  drawerHeaderUsernameText: '#fff',
  versionText: '#fff',
  logoutTitle: '#876fe9',
  logoutButtonLabel: '#876fe9',
  sideBarLabel: 'white',
  sideBarBackground: constants.Colors.DarkBlue1,

  //theme for dashboard match
  dashboardMatchTitle: '#fff',
  dashboardMatchTeamName: '#fff',
  dashboardMatchSeriesName: '#d6deff',
  dashboardMatchTimer: '#fff',
  dashboardMatchPlayBtn: '#ffdd50',
  dashboardMatchLineUpOutTitle: '#48bf6a',

  dashboardLeaderBoardBG: '#252d58',
  dashboardLeaderBoardIcon: '#fff',
  dashboardLeaderBoardTitle: '#fff',
  dashboardLeaderBoardDivider: '#fff',

  //header
  dashBoardHeaderBackground: 'linear-gradient(93deg, #192027 9%, #19232d 94%)',
  dashBoardHeaderSeperatorBg: '#2d353f',
  dashBoardHeaderSignUpBtn: '#ffc400',
  dashBoardLoginBtn: '#11171d',
  dashBoardLoginBtnLabel: '#ffc400',
  dashBoardHeaderXpCoinContainerBg: '#000000 0% 0% no-repeat padding-box',
  //sideBar
  dashBoardSideBarBackground: 'linear-gradient(158deg, #11171d 4%, #11171d 33%)',
  sideBarSectionBg: '#1a222d',
  //hometabs
  dashBoardHomeTabActiveText: '#000',
  dashBoardHomeTabInActiveText: '#fff',

  //gamePoster
  gamePosterFooterBg: '#192330',

  //cricketMatchCard
  cricketMatchCardBg:
    'transparent radial-gradient(closest-side at 63% 164%, #485B73 0%, #283039 100%) 0% 0% no-repeat padding-box',
  cricketMatchCardBoxShadow: '#020722B3',
  cricketMatchCardBorder: '#5e6c7d',
  cricketMatchCardTitle2: '#fff',
  cricketMatchCardText: '#fff',
  cricketMatchCardViewAllText: '#fff',
  //profile
  profileContainerBg:
    'transparent linear-gradient(180deg, #F6C53F 0%, #FFC300 100%) 0% 0% no-repeat padding-box',
  profileContainerBoxShadow: 'box-shadow: inset 0px 2px 15px #F6FF0063',
  //loginsignup_modal
  loginSignUpModalBg: '#181F27 0% 0% no-repeat padding-box',
  loginSingUpModalBoxShadow: '0px 0px 21px #09083D80',
  loginSignUpBtnBg:
    'transparent linear-gradient(180deg, #F6C53F 0%, #FFC300 100%) 0% 0% no-repeat padding-box',
  loginSignUpBtnBoxShadow: 'inset 0px 2px 15px #F6FF0063',
  loginSignUpSelectAllBtnDefault: 'white',
  loginSignUpSelectAllBtnActive: '#fac424',

  //footer
  footerBorder: '#707070',
  footerBackground: '#192330 0% 0% no-repeat padding-box'
};
